var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTheme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2615 -13380)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(665 104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.894,23.873H4.1V18.082L0,13.979l4.1-4.1V4.1H9.876l4.1-4.1,4.1,4.1h5.79v5.79l4.086,4.086-4.086,4.086v5.808H18.065l-4.086,4.086Z",
    transform: "translate(1954 13280)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.713,14.361A7.219,7.219,0,0,1,0,13.34,8.558,8.558,0,0,0,4.534,5.793,8.53,8.53,0,0,0,2.377.123,7.323,7.323,0,0,1,3.713,0,7.219,7.219,0,0,1,8.819,2.1a7.154,7.154,0,0,1,1.547,2.282,7.167,7.167,0,0,1,0,5.59,7.155,7.155,0,0,1-1.547,2.282,7.219,7.219,0,0,1-5.106,2.1Z",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 1964.027, 13287.113)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(2615 13380)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme);
export default __webpack_public_path__ + "static/media/theme.2a835326.svg";
export { ForwardRef as ReactComponent };